Button = require 'components/common/button'
SpinnerButton = require 'components/common/spinner_button'
ConnectStore = require 'components/enhancers/connect_store'
LaserActions = require 'actions/laser_actions'
LimitCounter = require 'components/common/limit_counter'
CreateQuestionInLaserDialog = require 'components/laser/create_question_in_laser_dialog'
MdgCreateQuestionDialog = require 'components/mdg_tables/create_question_dialog'
mediator = require 'mediator'
QuestionsActions = require 'actions/questions_actions'
QuestionsStore = require 'stores/questions_store'
LaserStore = require 'stores/laser_store'
Translation = require 'components/mixins/translation'
withLimits = require 'components/enhancers/with_limits'

storeConnector =
  QuestionsStore: (Store) ->
    isFetching: Store.isFetching()
    questionsCount: Store.getQuestionsCount()
    questionIds: Store.getQuestionsIds()

  LaserStore: (Store) ->
    isSyncing: Store.isSyncing()

QuestionsListToolbar = createReactClass
  displayName: "QuestionsListToolbar"

  propTypes:
    isFetching: PropTypes.bool.isRequired
    isSyncing: PropTypes.bool.isRequired
    questionsCount: PropTypes.number.isRequired
    questionIds: PropTypes.instanceOf(Immutable.List).isRequired
    limits: PropTypes.instanceOf(Immutable.Map).isRequired

  mixins: [Translation("es:question")]

  componentDidUpdate: (prevProps) ->
    return unless mediator.services.switches.isOn('laserConnect')
    return if @props.questionIds.isEmpty()
    return if prevProps.questionIds.equals(@props.questionIds)
    # Sync with Laser only if the feature is enabled
    # Trigger sync action with the current question IDs
    # Call the action to sync with Laser
    _.defer => # dispatch in the middle of the dispatch
      LaserActions.syncWithLaser(@props.questionIds)

  render: ->
    { isFetching, limits, questionsCount, questionIds, isSyncing } = @props

    isMdgTablesFeatureOn = mediator.services.switches.isOn 'mdgTables'
    isLaserConnectOn = mediator.services.switches.isOn 'laserConnect'

    return null if isFetching
    <div className="flex flex-row">
      <div className="flex-grow">
        <LimitCounter
          count={questionsCount}
          limit={limits.get('questions')}
          title={@i18n 'question_list'}
        />
      </div>
      {isMdgTablesFeatureOn && <div className="flex flex-row items-center justify-end">
        {isLaserConnectOn && <div className="mr-10">
          <SpinnerButton
            icon="synchronize"
            loading={isSyncing}
            className="btn btn-block btn-apply-inverted"
            label={@i18n '/actions.sync_with_laser'}
            onClick={() -> LaserActions.syncWithLaser(questionIds)}
          />
        </div>}
        <div className="mr-10">
          <Button
            className="btn btn-block btn-apply"
            label={@i18n '/actions.new_question'}
            onClick={QuestionsActions.openMdgCreateQuestionDialog}
          />
        </div>
        <CreateQuestionInLaserDialog/>
        <MdgCreateQuestionDialog />
      </div>}
    </div>

module.exports = withLimits(
  ConnectStore(QuestionsListToolbar, [QuestionsStore, LaserStore], storeConnector)
)
